var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgE2Ee = function SvgE2Ee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 7.5h10.5V15H3.75V7.5ZM14.25 6h-1.5v-.75a3.75 3.75 0 1 0-7.5 0V6h-1.5a1.5 1.5 0 0 0-1.5 1.5V15a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V7.5a1.5 1.5 0 0 0-1.5-1.5Zm-4.524 5.813a1.5 1.5 0 1 0-1.452 0A.751.751 0 0 0 8.25 12v.75a.75.75 0 0 0 1.5 0V12a.751.751 0 0 0-.024-.187ZM9 3a2.25 2.25 0 0 1 2.25 2.25V6h-4.5v-.75A2.25 2.25 0 0 1 9 3Z"
  })));
};
export default SvgE2Ee;